import Hero from "../components/home/Hero";
import Services from "../components/home/Services";
import Portfolio from "../components/home/Portfolio";

const R = "#FF2B2B", S1 = "#141414", BD = "rgba(255,255,255,0.07)";

const TICKER_ITEMS = [
  "3D Signage", "Brand Identity", "Printing", "Packaging", "Web Design", "Promotional Merch",
  "Large Format", "Digital Marketing", "Neon Signs", "Vehicle Branding", "Corporate Gifts",
];

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
.bp{background:#0A0A0A;color:#fff;font-family:'Inter',sans-serif;padding:48px clamp(16px,5vw,72px)}
.bp *{box-sizing:border-box}

/* ── Services ticker ── */
.ticker-wrap{overflow:hidden;background:${S1};border-top:1px solid ${BD};border-bottom:1px solid ${BD};padding:14px 0;margin:0 calc(-1 * clamp(16px,5vw,72px)) 64px}
.ticker-track{display:flex;width:max-content;animation:bm-ticker 30s linear infinite;white-space:nowrap}
.ticker-item{display:flex;align-items:center;gap:10px;padding:0 28px;font-size:12px;font-weight:600;color:rgba(255,255,255,.45);letter-spacing:1px;text-transform:uppercase}
.ticker-dot{width:5px;height:5px;border-radius:50%;background:${R};flex-shrink:0}
@keyframes bm-ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@media(prefers-reduced-motion:reduce){.ticker-track{animation:none}}
`;

function Ticker() {
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="ticker-wrap" aria-hidden="true">
      <div className="ticker-track">
        {items.map((item, i) => (
          <div className="ticker-item" key={i}>
            <span className="ticker-dot" />
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function HomePage() {
  return (
    <div className="bp">
      <style>{CSS}</style>
      <Hero />
      <Ticker />
      <Services />
      <Portfolio />
    </div>
  );
}